import { getDropdownMenuComponents } from "../logic";
var useDropdownMenuItems = function useDropdownMenuItems(items) {
  return getDropdownMenuComponents(items);
};
export default useDropdownMenuItems;